"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reservation_get = exports.availability_get = void 0;
exports.availability_get = "/api/car-hire/v1/availability/{pickUpAirportCode,pickUpDate,returnAirportCode,returnDate,driverAge,passengers}";
exports.reservation_get = "/api/car-hire/v1/reservation/{id,email,bookingId}";
